/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {getJpodConfigFirmware, PLATFORM_IDS} from '@ion/core/src/utils/DeviceUtils';
import {GridResult} from '@ion/dls/src/grid/PaginationControls';
import JobIdLinks from './JobIdLinks';

export interface PendingJpodConfigLinksType {
  data: GridResult;
  isVbuFwEnabled?: boolean;
}

export const PendingJpodConfigLinks = ({data, isVbuFwEnabled = true}: PendingJpodConfigLinksType) => {
  const filterPlatformIds = data?.fileHistoryPending?.filter((item) =>
    isVbuFwEnabled ? getJpodConfigFirmware(data, item.platformId)
      : item.platformId === PLATFORM_IDS.jpodConfig ||
      item.platformId === PLATFORM_IDS.jpod2Config
  );
  return <JobIdLinks data={filterPlatformIds?.[0]} pendingJobIds={filterPlatformIds} isPendingJpodConfig/>;
};

export default PendingJpodConfigLinks;
